import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
//import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import BaseDetailsContainer from './BaseDetailsContainer';

class BaseDialogContainer extends BaseDetailsContainer {
    constructor(props, service) {
        super(props);
        this.service = service;
        this.state = {closable: true};
    }
    prepareFooterItems() {
        const {viewMode} = this.props;
        switch (viewMode) {
            case 'EDIT':
            case 'NEW':
                return [
                    {label: 'Anuluj', onClick: this.props.onHide, className: 'gray'},
                    {
                        label: 'Zapisz',
                        className: 'float-right',
                        onClick: this.handleFormSubmit,
                    },
                ];
            case 'VIEW':
            default:
                return [];
        }
    }
    setElement() {
        const {viewMode, elementId} = this.props;
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, viewMode)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }
    renderDetails() {
        return;
    }
    prepareHeaderItems() {
        return [];
    }
    onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleFormSubmit();
        }
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }
    afterAddSuccess(response) {
        this.persistMessage('success', '', this.getAddSucces(response));
        this.props.afterSave();
    }
    afterUpdateSuccess(response) {
        this.persistMessage('success', '', this.getUpdateSucces(response));
        this.props.afterSave();
    }
    blockUi(callBack, waitPanelLabel) {
        this.props.blockUi(callBack, waitPanelLabel);
    }
    unblockUi(callBack) {
        this.props.unblockUi(callBack);
    }
    render() {
        const {className, id, key, name, onHide, visible, style} = this.props;
        return (
            // <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
            // <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
            <Dialog
                id={this.props.id}
                ref={this.props.dialogRef}
                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                header={this.renderHeader()}
                visible={visible}
                className={className}
                style={style}
                key={`${key ? key : id ? id : name}-dialog`}
                onHide={() => (onHide ? onHide() : null)}
                closable={this.state.closable}
            >
                {this.state.loading ? null : (
                    <Card footer={this.renderFooter()}>
                        <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                            {this.renderDetails()}
                        </form>
                    </Card>
                )}
            </Dialog>
            // </BlockUi>
        );
    }
}
BaseDialogContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    onHide: () => {},
    style: {minWidth: '300px'},
};

BaseDialogContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    style: PropTypes.object,
};

export default BaseDialogContainer;
